import {FormControl, FormHelperText, FormLabel, InputAdornment, MenuItem, TextField} from "@mui/material";
import React from "react"
import StatusComponent from "./StatusComponent";
import {useTranslation} from "i18nano";
import {preventDefaultOnDropFiles} from "../helpers/stubFunctions";
import {CommonProps} from "./types/types";
import {Choice} from "../api/types/Choice";
import {StatusUpdateAnswer} from "../types/UpdatePartyObject";
import {withSharedMemo} from "./memo/memoComponent";
import DisplayTextComponent from "./DisplayTextComponent";

interface DropdownComponentProps extends CommonProps {
    onChange: (event: React.ChangeEvent<HTMLInputElement>) => void;
    onFocus?: React.FocusEventHandler<HTMLInputElement | HTMLTextAreaElement>
    radioGroupName: string;
    choices: Choice[],
    other: boolean,
}

const DropdownComponent = ({
                               value,
                               onChange,
                               errorText = "",
                               onFocus,
                               status = StatusUpdateAnswer.NONE,
                               required, editable, displayText, radioGroupName, choices, other, id,
                               hint
    
                           }: DropdownComponentProps) => {
    const t = useTranslation();
    return (
        <FormControl disabled={!editable} required={required}>
            <FormLabel error={errorText !== ""} required={false} id={radioGroupName}>
                <DisplayTextComponent text={displayText} required={required} hint={hint}/>
            </FormLabel>
            <TextField error={errorText !== ""}
                       aria-labelledby="demo-radio-buttons-group-label"
                       name="dropdown-select"
                       id={id}
                       value={
                           `${value}`.includes("o:") || value === "Other" ? "Other" : value
                       }
                       disabled={!editable}
                       onChange={onChange}
                       onFocus={onFocus}
                       className={"paddingRightForDropdown"}
                       select
                       InputProps={{
                           endAdornment: <InputAdornment position="end" sx={{
                               position: "absolute",
                               right: "30px"
                           }}>
                               <StatusComponent status={status}/>
                           </InputAdornment>,
                       }}
            >
                {

                    choices?.map(choice => {
                        return (
                            <MenuItem key={choice.id} value={choice.id}>{choice.text}</MenuItem>
                        )
                    })
                }
                {other === true ? <MenuItem value={"Other"}>{t("Other")}</MenuItem> : null}
            </TextField>
            {
                value === "Other" || value.toString().indexOf("o:") !== -1
                    ?
                    <TextField onFocus={onFocus} error={errorText !== ""} sx={{marginTop: 1}} value={value.substring(2)}
                               onChange={e => {
                                   e.target.value = `o:${e.target.value}`;
                                   onChange(e as React.ChangeEvent<HTMLInputElement>);
                               }}
                               label={t("Other")} variant="outlined"
                               InputProps={{
                                   endAdornment: <InputAdornment position="end">
                                       <StatusComponent status={status}/>
                                   </InputAdornment>,
                               }}
                               disabled={!editable}
                               onDrop={preventDefaultOnDropFiles}
                    />
                    : null
            }
            {errorText !== "" ? <FormHelperText error>{errorText}</FormHelperText> : null}
        </FormControl>
    )
}

export default withSharedMemo(DropdownComponent);